module.exports = __webpack_public_path__ + "img/loaderV3_darkMode.40cf51f8.gif";